import * as React from 'react';

import { Card } from '@blueprintjs/core';
import CardContainer from '../common/CardContainer';

class TimeExpensePage extends React.Component<{}> {
    public render() {
        return (
            <>
                <CardContainer>
                    <Card elevation={1}>
                        <div className="card-header">Time & Expense</div>
                    </Card>
                </CardContainer>
            </>
        );
    }
}

export default TimeExpensePage;



// WEBPACK FOOTER //
// ./src/components/time/TimeExpensePage.tsx